export default "__VITE_ASSET__ByTTX4df__"